import React from 'react';
import PropTypes from 'prop-types';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';

import './reviews-sorting-select.scss';

export const SORTING = {
  MOST_RECENT: 'most-recent',
  HIGHEST_RATED: 'highest-rated',
  LOWEST_RATED: 'lowest-rated',
};

const OPTIONS = [
  {
    label: 'Most Recent',
    value: SORTING.MOST_RECENT,
  },
  {
    label: 'Highest Rated',
    value: SORTING.HIGHEST_RATED,
  },
  {
    label: 'Lowest Rated',
    value: SORTING.LOWEST_RATED,
  },
];

export const ReviewsSortingSelect = ({ onChange, selectedSorting }) => (
  <StyledSelect
    name="reviewsSorting"
    onChange={onChange}
    options={OPTIONS}
    value={selectedSorting}
    overrideClasses="reviews-sorting-select ps-0_5 pe-1_75 size-14 text-cool-gray-30"
    wrapperClassName="reviews-sorting-select-wrapper"
    labelText="Sort by:"
    labelClassName="size-14 fw-medium d-inline-block me-0_5"
  />
);

ReviewsSortingSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedSorting: PropTypes.oneOf(Object.values(SORTING)).isRequired,
};
